class InvalidXPathError extends Error {
  constructor(msg: string) {
    super(msg);
    //https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, InvalidXPathError.prototype);
    this.name = 'InvalidXPathError';
  }
}
export default InvalidXPathError;
